<lin-layout-section title="{{ 'ADMIN.CLIENTS.USERS.NEW_USER' | translate }}">
  @if (user?.isAdmin()) {
  <lin-layout-section-meta
    label="{{ 'ADMIN.CLIENTS.USERS.COMPANY' | translate }}"
    routerLink="/admin/clients/{{ client?.id }}/company-info"
    [value]="client?.name"
  ></lin-layout-section-meta>
  } @if (!isLoaded) {
  <lin-spinner></lin-spinner>
  } @if (isLoaded) {
  <lin-user-form [client]="client" (save)="navigateToList()"></lin-user-form>
  }
</lin-layout-section>
